import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ErrorSnackbarComponent } from '../snackbars/error-snackbar/error-snackbar.component';
import { SuccessSnackbarComponent } from '../snackbars/success-snackbar/success-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  readonly snackbar = inject(MatSnackBar);

  showSuccess(message: string, duration = 30000): void {
    const config: MatSnackBarConfig = {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      data: { message, action: 'Schließen' }
    };
    this.snackbar.openFromComponent(SuccessSnackbarComponent, config);
  }

  showError(message: string, duration = 30000): void {
    const config: MatSnackBarConfig = {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      data: { message, action: 'Schließen' }
    };
    this.snackbar.openFromComponent(ErrorSnackbarComponent, config);
  }
}
